function initPhoneCarousels() {
  const carousels = document.querySelectorAll("[data-phone-carousel]");

  carousels.forEach((carousel) => {
    const track = carousel.querySelector("[data-carousel-track]");
    const slides = Array.from(carousel.querySelectorAll("[data-carousel-slide]"));
    const prevButton = carousel.querySelector("[data-carousel-prev]");
    const nextButton = carousel.querySelector("[data-carousel-next]");
    const dotsRoot = carousel.querySelector("[data-carousel-dots]");
    if (!track || slides.length === 0 || !prevButton || !nextButton || !dotsRoot) return;

    let currentIndex = 0;
    let autoTimer = null;
    const shouldAutoplay = carousel.dataset.carouselAutoplay !== "false"
      && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const dots = slides.map((_, index) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "carousel-dot";
      dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
      dot.addEventListener("click", () => {
        currentIndex = index;
        update();
      });
      dotsRoot.appendChild(dot);
      return dot;
    });

    function update() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === currentIndex);
      });
    }

    function startAuto() {
      if (!shouldAutoplay) return;
      autoTimer = window.setInterval(() => {
        currentIndex = (currentIndex + 1) % slides.length;
        update();
      }, 4000);
    }

    function resetAuto() {
      if (!shouldAutoplay) return;
      window.clearInterval(autoTimer);
      startAuto();
    }

    prevButton.addEventListener("click", () => {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      update();
      resetAuto();
    });

    nextButton.addEventListener("click", () => {
      currentIndex = (currentIndex + 1) % slides.length;
      update();
      resetAuto();
    });

    update();
    startAuto();
  });
}

function initWatchCarousels() {
  const mockups = document.querySelectorAll("[data-complication-mockup]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  mockups.forEach((mockup) => {
    const cycle = mockup.querySelector(".complication-family-cycle");
    const pager = mockup.parentElement.querySelector(".carousel-dots");
    if (!cycle || !pager) return;

    const images = cycle.querySelectorAll("img");
    const buttons = pager.querySelectorAll("button");
    if (images.length === 0 || images.length !== buttons.length) return;

    let index = 0;
    let timer = null;

    function setActive(nextIndex) {
      images[index].classList.remove("is-active");
      buttons[index].classList.remove("is-active");
      index = ((nextIndex % images.length) + images.length) % images.length;
      images[index].classList.add("is-active");
      buttons[index].classList.add("is-active");
    }

    function start() {
      if (timer !== null || reducedMotion) return;
      timer = window.setInterval(() => setActive(index + 1), 3500);
    }

    function stop() {
      if (timer === null) return;
      window.clearInterval(timer);
      timer = null;
    }

    buttons.forEach((button, buttonIndex) => {
      button.addEventListener("click", () => {
        setActive(buttonIndex);
        stop();
        start();
      });
    });

    ["mouseenter", "focusin"].forEach((eventName) => mockup.addEventListener(eventName, stop));
    ["mouseleave", "focusout"].forEach((eventName) => mockup.addEventListener(eventName, start));

    let touchStartX = null;
    mockup.addEventListener("touchstart", (event) => {
      touchStartX = event.touches[0].clientX;
      stop();
    }, { passive: true });
    mockup.addEventListener("touchend", (event) => {
      if (touchStartX === null) return;
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      if (deltaX > 40) setActive(index - 1);
      else if (deltaX < -40) setActive(index + 1);
      touchStartX = null;
      start();
    }, { passive: true });

    start();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initPhoneCarousels();
  initWatchCarousels();
});
